'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $is_Lapp_auth_OperationalUserWithClient$Raw(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_auth_OperationalUserWithClient$Raw)));
}
export { $is_Lapp_auth_OperationalUserWithClient$Raw as $is_Lapp_auth_OperationalUserWithClient$Raw };
function $isArrayOf_Lapp_auth_OperationalUserWithClient$Raw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_OperationalUserWithClient$Raw)));
}
export { $isArrayOf_Lapp_auth_OperationalUserWithClient$Raw as $isArrayOf_Lapp_auth_OperationalUserWithClient$Raw };
//# sourceMappingURL=app.auth.-Operational-User-With-Client$-Raw.js.map
